export type UiState = {
  wsPopupsEnabled: boolean;
};

const state: UiState = {
  wsPopupsEnabled: false,
};

export default {
  state,
  mutations: {
    SET_WS_POPUPS_ENABLED(moduleState: UiState, enabled: boolean): void {
      moduleState.wsPopupsEnabled = enabled;
    },
  },
  getters: {
    wsPopupsEnabled(moduleState: UiState): boolean {
      return !!moduleState.wsPopupsEnabled;
    },
  },
};
